// Mock data for navraj.ai personal website

export const siteConfig = {
  name: "navraj.ai",
  tagline: "Building platforms for the next decade.",
  email: "hello@navraj.ai",
  linkedin: "https://linkedin.com/in/navraj",
  twitter: "https://twitter.com/navraj",
  nexper: "https://nexper.ai/navraj"
};

export const heroData = {
  headline: "I build intelligent platforms at the intersection of AI, Cloud, and Product.",
  subheadline: "Principal Solutions Architect. Founder. Systems thinker.",
  description: "Designing scalable SaaS, AI-native platforms, and cloud architectures used by real businesses."
};

export const aboutData = {
  title: "Hi, I'm Navraj.",
  paragraphs: [
    "I'm a Principal Solutions Architect and product founder with 20+ years in software, cloud, and systems architecture.",
    "I specialize in designing and building scalable SaaS platforms, AI-powered products, and cloud-native systems—from zero to production, and from prototype to platform.",
    "By day, I architect large-scale systems in enterprise environments across Azure, .NET, Node.js, and modern cloud platforms. By night (and weekends), I build my own products and companies—obsessed with product-market fit, automation, and leverage.",
    "I'm not interested in building 'apps'. I build platforms."
  ]
};

export const servicesData = {
  title: "What I Build",
  items: [
    {
      id: 1,
      icon: "Rocket",
      title: "SaaS Platforms",
      description: "Multi-tenant, scalable systems with real-world billing, auth, workflows, and ops."
    },
    {
      id: 2,
      icon: "Bot",
      title: "AI-Native Products",
      description: "AI-first workflows, automation, decision systems, and intelligent UX."
    },
    {
      id: 3,
      icon: "Cloud",
      title: "Cloud Architecture",
      description: "Azure-native, cost-efficient, secure, production-grade systems."
    },
    {
      id: 4,
      icon: "Cpu",
      title: "Developer Platforms",
      description: "Languages, runtimes, orchestration systems, internal platforms, tooling ecosystems."
    }
  ]
};

export const projectsData = {
  title: "Things I'm Building",
  items: [
    {
      id: 1,
      name: "NEXPER.ai",
      tagline: "Expert Marketplace + CRM Platform",
      description: "An AI-powered expert marketplace + CRM platform helping consultants, coaches, and professionals run and grow their business.",
      features: ["Booking", "Payments", "Video meetings", "CRM", "AI insights", "Business operations"],
      note: "Think: Shopify + Calendly + CRM + AI — for experts.",
      status: "Active"
    },
    {
      id: 2,
      name: "Aurum",
      tagline: "Enterprise Data Platform",
      description: "A data ingestion, transformation, and distribution platform for structured business data pipelines.",
      features: ["InStreams / Deposits / OutStreams", "Enterprise-grade data flows", "Built on .NET 8 & Azure"],
      status: "Active"
    },
    {
      id: 3,
      name: "STARKLANG",
      tagline: "Next-Gen Programming Language",
      description: "A high-performance, AI-native, cloud-first programming language and runtime.",
      features: ["Tensor-native", "Concurrency-first", "Cloud-native primitives", "Custom VM (STARKVM)"],
      note: "A long-term bet on the future of software.",
      status: "In Development"
    }
  ]
};

export const philosophyData = {
  title: "How I Think",
  intro: "I believe the next generation of software will not be:",
  notList: ["CRUD apps", "Or glued-together SaaS"],
  willBe: "It will be:",
  willBeList: ["AI-native", "Platform-centric", "Automation-first", "Designed for leverage, not headcount"],
  optimizeFor: "I optimize for:",
  optimizeList: ["Scale", "Simplicity", "Long-term optionality", "Real-world usability"]
};

export const experienceData = {
  title: "Background",
  highlights: [
    "20+ years in software & systems engineering",
    "Principal Solutions Architect at iSOFT ANZ",
    "Led large-scale digital banking and enterprise platforms",
    "Founder of multiple product ventures"
  ],
  expertise: [
    "Azure",
    ".NET",
    "Node.js",
    "React / React Native",
    "Cloud-native & distributed systems"
  ]
};

export const contactData = {
  title: "Let's Talk",
  description: "If you want to talk about:",
  topics: ["Platforms", "AI products", "Architecture", "Startups", "Or interesting problems"],
  outro: "You can reach me here:"
};

export const navItems = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Philosophy", href: "#philosophy" },
  { label: "Experience", href: "#experience" }
];
